import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  IBriefInfluencerV2,
  IDataFieldValue,
} from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_DATA_FIELDS_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

interface IEditDataFieldV2DataRequest {
  briefInfluencerIds: string[];
  dataField: { [key: string]: IDataFieldValue };
  handleSuccess: (
    data: { id: string; briefInfluencer: IBriefInfluencerV2 }[]
  ) => void;
}

export function useEditDataFieldV2DataBulk(briefId: string) {
  const {
    mutate: editDataField,
    isLoading: isEditing,
    isSuccess: isEdited,
    variables,
  } = useMutation({
    mutationFn: (data: IEditDataFieldV2DataRequest) =>
      BriefService.editDataFieldV2DataBulk(
        data.briefInfluencerIds,
        data.dataField
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, { handleSuccess }) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, briefId],
      });
      const successData = data.data.filter((item) => item.status === "success");

      handleSuccess(
        successData.map((item) => ({
          id: item.briefInfluencerId,
          briefInfluencer: item.briefInfluencer,
        }))
      );
    },
  });

  return {
    editDataField,
    isEditing,
    isEdited,
    editDataFieldVariables: variables,
  };
}
